import { css, FlattenSimpleInterpolation } from 'styled-components';
import { mediaQueries } from './config';

export const moduleContentPaddingX: FlattenSimpleInterpolation = css`
  padding-left: 1.5rem;
  padding-right: 1.5rem;

  ${mediaQueries.md} {
    padding-left: 5.25rem;
    padding-right: 5.25rem;
  }
`;

export const moduleWithCalloutContentPaddingX: FlattenSimpleInterpolation = css`
  ${mediaQueries.md} {
    padding-left: 6rem;
    padding-right: 6rem;
  }
`;

export const articleContentPadding: FlattenSimpleInterpolation = css`
  padding-left: 1.5rem;
  padding-right: 1.5rem;

  ${mediaQueries.sm} {
    padding-left: 2.25rem;
  }
`;

export const articleInnerTextFullWidth: FlattenSimpleInterpolation = css`
  margin-right: -1.5rem;
  margin-left: -1.5rem;
  min-width: calc(100% + 1.5rem * 2);

  ${mediaQueries.sm} {
    margin-left: -2.25rem;
    min-width: calc(100% + 1.5rem + 2.25rem);
  }
`;

export const articleInnerTextFullWidthMdUpExtraWide: FlattenSimpleInterpolation = css`
  ${articleInnerTextFullWidth};

  ${mediaQueries.md} {
    min-width: calc(120% + 1.5rem + 2.25rem);
  }
`;

export default {
  moduleContentPaddingX,
  moduleWithCalloutContentPaddingX,
  articleContentPadding,
  articleInnerTextFullWidth,
  articleInnerTextFullWidthMdUpExtraWide,
};
